"use client"

import { usePathname } from 'next/navigation'
import { AuthProvider } from '@/hooks/useAuth'
import AuthedLayout from './AuthedLayout'
import { Toaster } from './ui/sonner'
import { useEffect, useState } from 'react'
import { PermissionProvider } from '../contexts/PermissionContext'

interface AppLayoutProps {
  children: React.ReactNode
}

export default function AppLayout({ children }: AppLayoutProps) {
  const pathname = usePathname()
  const [isAuthRoute, setIsAuthRoute] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    // Determine auth route on client after hydration
    const currentPath = pathname || window.location.pathname
    const authRoute =
      currentPath?.startsWith('/login') ||
      currentPath?.startsWith('/forgot-password') ||
      currentPath?.startsWith('/reset-password')
    
    setIsAuthRoute(authRoute)
    setIsMounted(true)
  }, [pathname])

  return (
    <PermissionProvider>
      {/* Keep the permission context mounted while the client determines the route. */}
      {!isMounted ? (
        <div suppressHydrationWarning>{children}</div>
      ) : isAuthRoute ? (
        <div suppressHydrationWarning>{children}</div>
      ) : (
        <div suppressHydrationWarning>
          <AuthProvider>
            <AuthedLayout>{children}</AuthedLayout>
            <Toaster />
          </AuthProvider>
        </div>
      )}
    </PermissionProvider>
  )
}
